import { createSlice } from "@reduxjs/toolkit";
import { stateEnum } from "../constants/enum";

const { flrn } = stateEnum;

let initialState = {
    detailParams: {},
    isNewEntry: false
};


const flrnSlice = createSlice({
    name: flrn,
    initialState,
    reducers: {
        setNewEntryMode: (state, action) => {
            state.isNewEntry = action.payload;
        },
        setDetailParams: (state, action) => {
            state.detailParams = action.payload
          },
        resetDetail: (state) => {
            state.detailParams = {};
            state.isNewEntry = true;
        },
    },
    
});


export const { setNewEntryMode,setDetailParams, resetDetail } = flrnSlice.actions;
export default flrnSlice.reducer;
